import { t } from 'i18next';
import React from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Card, Col, Row } from 'react-bootstrap';
import { Icon, TooltipHost } from '@fluentui/react';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import moment from 'moment';
import NoDataLayer from '../../../../../Common/NoDataLayer';

class CONTRACT_KPI_COVERAGE extends React.Component {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    inputParam_HideHeader: PropTypes.bool,
    inputParam_ComponentContent: PropTypes.bool,
    inputParam_UseFake: PropTypes.bool,
  };

  static defaultProps = {
    inputParam_HideHeader: false,
    inputParam_ComponentContent: null,
    inputParam_UseFake: false,
  };

  renderContent() {
    return <>
      <Row className='mx-2 mt-3 mb-1 border-top border-bottom border-end' style={{borderLeft: "10px solid green"}}>
        <Col>
            <Row>
              <Col className='text-center font-weight-bold' style={{fontSize: "32px", fontWeight: "bold"}}>
                {
                  !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent.items[0].item_cobertura ?
                  this.props.inputParam_ComponentContent.items[0].item_cobertura.displayValue : '--') : '--'
                }
              </Col>
            </Row>
            <Row>
              <Col className='text-center'>{t('data-lang-lbl-coverageupper')}</Col>
            </Row>
        </Col>
        <Col>
          <Row>
            <Col className='text-center font-weight-bold' style={{fontSize: "32px", fontWeight: "bold"}}>
              {
                  !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent.items[0].item_cobertura ?
                  this.props.inputParam_ComponentContent.items[0].item_cobertura.valueGoal : '--') : '--'
              }
            </Col>
          </Row>
          <Row>
            <Col className='text-center'>{t('data-lang-lbl-goalupper')}</Col>
          </Row>
        </Col>
      </Row>
      <Row className='pt-3 mx-2 mt-1 mb-3 d-flex align-items-center'>
        <Col>
          <Row>
            <Col xl={12} className='text-center'><Icon iconName='Calendar' styles={{root:{fontSize: "36px", color: "green"}}} /></Col>
            <Col xl={12} className='text-center font-weight-bold'>{!this.props.inputParam_UseFake ? moment(this.props.inputParam_ComponentContent.items[0].startDate).format("DD/MM/YYYY") : '--'}</Col>
          </Row>
        </Col>
        <Col className='d-flex align-items-center'>
          <Icon iconName='DoubleChevronLeftMedMirrored' styles={{root:{fontSize: "26px"}}} />
        </Col>
        <Col>
          <Row>
            <Col xl={12} className='text-center'><Icon iconName='Calendar' styles={{root:{fontSize: "36px", color: "red"}}} /></Col>
            <Col xl={12} className='text-center font-weight-bold'>{!this.props.inputParam_UseFake ? moment(this.props.inputParam_ComponentContent.items[0].endDate).format("DD/MM/YYYY") : '--'}</Col>
          </Row>
        </Col>
      </Row>
    </>
  }

  render() {
    return (
      <>
      {
        !this.props.inputParam_UseFake &&
        <Card className='h-100'>
          {
            !this.props.inputParam_HideHeader &&
            <Card.Header className="card-header-compact">
              <Card.Title className="d-flex justify-content-between">
                <b>{ (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.boardComponentTitle) ?? t('data-lang-boxname-coverage')}</b>
                <div className='toolbar d-flex'>
                  <HEADER_TOOLBAR
                    inputParam_BoardStructure={this.props.inputParam_BoardStructure}
                    inputParam_Container={this.props.inputParam_Container}
                  />
                </div>
              </Card.Title>
            </Card.Header>
          }
          <Card.Body className='px-1 py-0 h-100'>
            {
              (this.props.inputParam_ComponentContent && this.props.inputParam_ComponentContent.items) && this.renderContent()
            }
            {
              (!this.props.inputParam_ComponentContent || !this.props.inputParam_ComponentContent.items) &&
              <NoDataLayer display={true} />
            }
          </Card.Body>
        </Card>
      }
      { this.props.inputParam_UseFake && this.renderContent()}
      </>
    );
  }
}

export default CONTRACT_KPI_COVERAGE;